import { useEffect, useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { sunboundPayProxy } from '@proxies';
import { useSpinnerContext, useSessionContext } from '@contexts';
import { StatusCodes } from "http-status-codes";
import { isApiError } from '@app-types';
import { authStore } from '@stores';

interface CheckSessionProps {
    redirectPath: string;
}

const CheckSession = ({ redirectPath }: CheckSessionProps) => {

    const authStatus = authStore.useStatus();
    const { setSpinnerShow } = useSpinnerContext();
    const { session, setSession } = useSessionContext();
    const location = useLocation();
    const [sessionCheckFailed, setSessionCheckFailed] = useState(false);

    useEffect(() => {
        (async () => {
            if (session === null) {
                setSpinnerShow(true);
                try {
                    const rawSession = await sunboundPayProxy.refreshSession();
                    setSession(rawSession);
                } catch (error) {
                    console.log(error);
                    if (isApiError(error) && error.response?.status === StatusCodes.UNAUTHORIZED)
                        setSessionCheckFailed(true);
                } finally {
                    setSpinnerShow(false);
                }
            }
        })();
    }, []);

    if (authStatus === `unauthorized` || sessionCheckFailed) {
        return <Navigate to={redirectPath} state={{ unauthorized: true, from: location }} replace />;
    }

    if (session) {
        return (<Outlet />);
    }

    return (<div></div>);

};

export default CheckSession;
